/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
export const sortValues = (a, b) => {
  // Get first element of array values
  a = Array.isArray(a) ? a[0] : a;
  b = Array.isArray(b) ? b[0] : b;

  // Force null and undefined to the bottom
  a = a === null || a === undefined ? (isNaN(b) ? '' : -Infinity) : a;
  b = b === null || b === undefined ? (isNaN(a) ? '' : -Infinity) : b;

  // Force any string values to lowercase
  a = typeof a === 'string' ? a.toLowerCase() : a;
  b = typeof b === 'string' ? b.toLowerCase() : b;

  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  // Returning 0, undefined or any falsey value will
  // use subsequent sorts or the index as a tiebreaker
  return 0;
};

export const sortRowValues = (a, b) => sortValues(a.value, b.value);
